import React from 'react';
import { Link } from 'react-router-dom';
import SharedNavbar from '../components/SharedNavbar';
import './DMBoKPage.css';
import dmbok from '../assets/images/DAMA-DMBOK.png';

const DMBoKPage = () => {
  return (
    <div className="dmbok-page">
      <SharedNavbar />

      {/* ===== HERO ===== */}
      <section className="dmbok-hero">
        <div className="dmbok-hero-content">
          <h1>DMBOK®</h1>
          <div className="dmbok-hex-deco">
            <div className="hex h1"></div>
            <div className="hex h2"></div>
            <div className="hex h3"></div>
            <div className="hex h4"></div>
            <div className="hex h5"></div>
          </div>
        </div>
      </section>

      {/* ===== BREADCRUMB ===== */}
      <div className="dmbok-breadcrumb">
        <Link to="/">🏠</Link>
        <span> &rsaquo; </span>
        <Link to="/learning">Learning</Link>
        <span> &rsaquo; </span>
        <span>DMBoK</span>
      </div>

      {/* ===== INTRO ===== */}
      <section className="dmbok-intro">
        <div className="dmbok-container">
          <p>
            The <strong>DMBoK® 2 Revised Edition</strong> is an essential resource for individuals preparing
            for the <strong>Certified Data Management Professional (CDMP®)</strong> qualification, developed
            by <strong>DAMA International</strong>. It serves as a comprehensive study guide, supporting
            candidates in the <strong>Information Systems CORE Examination</strong> and the additional
            assessments required for certification.
          </p>
          <p className="dmbok-note">
            <strong>When ordering, please ensure you provide a full postal address and mobile number
            for tracking purposes — thank you.</strong>
          </p>
        </div>
      </section>

      {/* ===== BOOK SECTION ===== */}
      <section className="dmbok-book-section">
        <div className="dmbok-container">
          <div className="dmbok-book-grid">

            <div className="dmbok-book-cover">
              <img src={dmbok} alt="DAMA-DMBOK Book" className="dmbok-book-img" />
            </div>

            <div className="dmbok-purchase-box">
              <h2>DMBoK® Version 2 – Revised Edition</h2>

              {/* Digital */}
              <p className="dmbok-option-title">Get instant access to the DMBoK®2 in digital format.</p>
              <p className="dmbok-option-sub">Purchase your digital copy directly from DAMA International.</p>
              <a
                href="https://www.dama.org/cpages/body-of-knowledge"
                target="_blank"
                rel="noreferrer"
                className="dmbok-btn"
              >
                Buy Digital Version ↗
              </a>

              <hr className="dmbok-divider" />

              <p className="dmbok-option-title">The DMBoK®2 hardcopy is also available for purchase below.</p>

              {/* Non-Members — désactivé */}
              <p className="dmbok-price nonmember">Non-Member Price — Contact us for pricing</p>
              <button className="dmbok-btn dmbok-btn-disabled" disabled>
                Buy Hardcopy – Non-Members
              </button>

              {/* Members — désactivé */}
              <p className="dmbok-price member">Member Price — Exclusive discount for DAMA Tunisia members</p>
              <button className="dmbok-btn dmbok-btn-disabled" disabled>
                Buy Hardcopy – Members
              </button>

              <p className="dmbok-coming-soon">🔒 Hardcopy ordering coming soon</p>
            </div>

          </div>
        </div>
      </section>

      {/* ===== UPCOMING DMBoK 3 ===== */}
      <section className="dmbok-upcoming">
        <div className="dmbok-container">
          <div className="dmbok-upcoming-box">
            <h3>Upcoming DMBoK®3</h3>
            <p>
              DAMA International is developing DMBoK® 3.0, the next evolution of the Data Management
              Body of Knowledge. Visit our DMBoK® 3 updates page to learn more about the project,
              access webinar updates, and see future opportunities that may be relevant for DAMA Tunisia members.
            </p>
            <Link to="/dmbok3" className="dmbok-btn dark">
              VIEW DMBoK® 3 UPDATES →
            </Link>
          </div>
        </div>
      </section>

      {/* ===== JOIN CTA ===== */}
      <section className="dmbok-join">
        <div className="dmbok-container">
          <div className="dmbok-join-box">
            <p>
              Not a member yet? Join today to gain access to key educational resources
              and unlock exclusive DAMA Tunisia membership benefits.
            </p>
            <Link to="/membership" className="dmbok-btn dark">
              JOIN DAMA TUNISIA ↗
            </Link>
          </div>
        </div>
      </section>

      {/* ===== CTA GRID ===== */}
      <section className="dmbok-cta">
        <div className="dmbok-container">
          <div className="dmbok-cta-grid">
            <Link to="/events" className="dmbok-cta-btn">
              <strong>Events</strong>
              <span>Discover upcoming and past events</span>
            </Link>
            <Link to="/about" className="dmbok-cta-btn">
              <strong>Sponsor us</strong>
              <span>Connect with the Tunisian data community</span>
            </Link>
          </div>
        </div>
      </section>

    </div>
  );
};

export default DMBoKPage;